import { Container } from "reactstrap";
import Header from "components/Headers/Header.js";
import { useState } from "react";
import LoadingSpinner from "components/Common/LoadingSpinner";
import ErrorAlert from "components/Common/ErrorAlert";
import NotificationAlert from "components/Common/NotificationAlert";
import ReferralStatsCards from "components/Referrals/ReferralStatsCards";
import ReferralSettings from "components/Referrals/ReferralSettings";
import ReferralTable from "components/Referrals/ReferralTable";
import { useGetAllUsers } from "lib/api-referral";

const Referrals = () => {
    const [alert, setAlert] = useState({
        show: false,
        message: "",
        color: "",
        duration: 3000,
    });

    const {
        data: usersResponse,
        isLoading,
        isError,
        error,
        refetch,
    } = useGetAllUsers();

    const showAlert = (message, color, duration = 3000) => {
        setAlert({ show: true, message, color, duration });
    };

    const hideAlert = () => {
        setAlert({ show: false, message: "", color: "" });
    };

    const usersData = usersResponse || [];

    if (isLoading) {
        return (
            <>
                <Header />
                <LoadingSpinner message="Loading referral data..." />
            </>
        );
    }

    if (isError) {
        return (
            <>
                <Header />
                <ErrorAlert error={error} onRetry={refetch} />
            </>
        );
    }

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                <NotificationAlert alert={alert} onClose={hideAlert} />

                <ReferralStatsCards usersData={usersData} />

                <ReferralSettings 
                    showAlert={showAlert}
                    onRefresh={refetch}
                />

                <ReferralTable
                    usersData={usersData}
                    onRefresh={refetch}
                    showAlert={showAlert}
                />
            </Container>
        </>
    );
};

export default Referrals;